import { render, staticRenderFns } from "./VersionAddress.vue?vue&type=template&id=c260a2de&scoped=true"
import script from "./VersionAddress.vue?vue&type=script&lang=js"
export * from "./VersionAddress.vue?vue&type=script&lang=js"
import style0 from "./VersionAddress.vue?vue&type=style&index=0&id=c260a2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c260a2de",
  null
  
)

export default component.exports